<template>
    <div class="field is-horizontal">
        <div class="field-label">
            <label class="label">Win max:</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control">
                    <div class="select" :class="{ 'is-loading': isLoading }" :disabled="isLoading">
                        <select v-model="groupMaxWins">
                            <option v-for="win in getMaxWins">{{ win }}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            isLoading() {
                return this.$store.getters.getGroupLoadingStatus
            },
            getMaxWins() {
                return this.$store.getters.getGroupSettings.max_group_bids
            },
            groupMaxWins: {
                get() {
                    return this.$store.getters.getSelectedGroup.max_wins
                },
                set(value) {
                    this.$store.dispatch('changeSelectedGroupFieldValue',  {field: 'max_wins', value: value})
                }
            }
        }
    }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Auctions/Advance/BiddingModal/Inputs/GroupWinsSelect.vue